'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.config(function ($httpProvider) {
  $httpProvider.interceptors.push('noCacheInterceptor');
});

/**
 * Interceptor to reproduce the jQuery ajaxSetup({ cache : false }) behaviour.
 * Adds a '_={timestamp}' parameter to GET requests when config.cache !== true
 * for REST requests only.
 */
ngModule.factory("noCacheInterceptor", function () {
  var restRegexp = /^\/rest\/.*/;
  return {
    'request': function request(_request) {
      if (_request.method === "GET" && _request.cache !== true && restRegexp.test(_request.url)) {
        if (!_request.params) {
          _request.params = {};
        }
        _request.params._ = new Date().getTime();
      }
      return _request;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/http/noCacheHttpInterceptor.js
// module id = 2713
// module chunks = 13